// Module
var code = "<availability-calendar-dashboard ng-if=$ctrl.canInit component-is-ready=$ctrl.componentIsReady() changes-saved=$ctrl.changesSaved() is-admin=$ctrl.$user.isAdmin() is-host=$ctrl.$user.isHost()></availability-calendar-dashboard>";
// Exports
module.exports = code;